import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal } from 'semantic-ui-react';
//import { useHistory, BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Utility from './../../../Utility';
import GlobalContext from '../../../contexts/GlobalContext';
//import ModalTransition from '../../ModalTransition/ModalTransition';
//import LoginPage from './../../../pages/LoginPage/LoginPage';
//import { config } from "./../../../Config";
import './ModalRedirect.css';
//import GenerateLink from '../GenerateLink/GenerateLink';
import API, {ErrorManagement, ResponseManagement} from "../../../API";


/**
 * 
 * @param {*} props 
 */
const ModalRedirect = ( props ) => {

    const [theLink, setTheLink] = useState("");
    const [globalContext] = useContext(GlobalContext);

    useEffect(() => {
        // document.getElementById("redirection").setAttribute("href", theLink);
        // Met à jour le titre du document via l’API du navigateur    document.title = `Vous avez cliqué ${count} fois`;
        setLink()
    }, []);

    const setLink = () => {
        let manualUrl = '/generateTemporaryLink';

        let dataForLink = {
            customerAreaId: globalContext.user.customerAreaId,
            establishmentId: globalContext.establishment.id,
            type: "initializePassword",
            //type: props.typeLink,
            langIso: props.langIso,
            expirationDate: "",
            data: [],
        };

        API.post( Utility.getUrlAjax() + manualUrl, dataForLink ).then(response => {
            ResponseManagement(response,
              () => {
                //console.log(response)
                  if (response.data.success == "true") {
                      setTheLink( response.data.data.url );
                      // theLink = response.data.data.url;
                  }
              },
              () => {
              }
            );
        }).catch(error => {
            ErrorManagement(error, () => { });
        })
    }

    const getMessage = () => {
        let messageButton = "";

        if (props.typeLink === "login") {
            messageButton = globalContext.translations.connection
        }
        else{
            messageButton = globalContext.translations.initializationPassword
        }
        return messageButton
        //return <Button id="redirection" as={Link} target="_self" positive to={ theLink } >{messageButton}</Button>
        // return <Link id="redirection"  className="ui green button nav_returnlink" target="_self" to={ theLink } >{messageButton}</Link>
    }

    return (
        <Modal id="ModalRedirect" open={props.open} onClose={() => props.handleClose(false)}>
            {<Modal.Header>{globalContext.translations.limitedAccess}</Modal.Header>}
            <Modal.Content >
                <Modal.Description>
                    { props.typeLink == "login"
                    ? globalContext.translations.redirectPageLogin
                    : globalContext.translations.redirectPageCreateMdp
                    }
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions centered="true">
                {/*<Button className="ui green button" id="redirection" onClick={e => handleSuccessClick(e)}>{getMessage()}</Button>*/}
                <a className="ui green button" id="redirection" href={theLink}>{getMessage()}</a>
                <Button negative onClick={() => props.handleClose(false)}>{globalContext.translations.back}</Button>
            </Modal.Actions>
        </Modal>
    );

}

export default ModalRedirect

